import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import { authFuncData } from "../../../../AdminApi/commFunc";
import { RoleEnum } from "../../../../Enum/auth.Enum";
import { useApi } from "../../../../hooks/useApi";
import useGradeList from "../../../../hooks/useGradeList";
import ConfirmBtn from "../../../Button/ConfirmBtn";
import Flex from "../../../DefaultStyles/Flex";
import Loader from "../../../DefaultStyles/Loader";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import AlertModal from "../../../Modal/AlertModal";
import DefaultModalLayout, {
  defaultModalType,
} from "../../../Modal/DefaultModalLayout";
import { DeleteModalLabel } from "../../Users/UserDetail/CommentModal/CommentDeleteModal";
import { DefaultModalCommonProps } from "../../Users/UserDetail/CommentModal/CommentModal";
import ManagerAuthItem from "./ManagerAuthModal/ManagerAuthItem";

interface IAuthFuncData {
  id: number;
  title: string;
  desc: string;
  state: string;
}

interface ManagerAuthModalProps extends DefaultModalCommonProps {
  gradeName?: string;
}

export default function ManagerAuthModal({
  closeEvent,
  confirmEvent,
  gradeName,
}: ManagerAuthModalProps) {
  console.log(gradeName);

  const gradeOption = useGradeList();
  console.log(gradeOption);

  const [modalType, setModalType] = useRecoilState(defaultModalType);
  const [filter, setFilter] = useState({
    grade: -1,
  });
  const [grade, setGrade] = useState<OptionType>({
    value:
      gradeName !== "" && gradeOption?.length > 1
        ? gradeOption?.find(
            (val) =>
              val.label?.replace(" ", "")?.split("관리자")[0] === gradeName
          )?.value
        : "",
    label: gradeName !== "" ? gradeName : "선택",
  });
  const [saveAlert, setSaveAlert] = useState(false);
  const [saveBtnClick, setSaveBtnClick] = useState(false);

  type authStateType = typeof authState;

  const { response: authListResponse, loading: authLoading } = useApi({
    method: "get",
    url: filter?.grade !== -1 ? `auth/detail?id=${filter?.grade}` : undefined,
  });

  console.log("🧡 server", authListResponse?.data[0]);

  const [authState, setAuthState] = useState({
    userInfo: false, // 회원 정보 열람
    partyInfo: false, // 파티 정보 열람
    partyCancel: false, // 파티 취소
    black: false, // 블랙리스트 설정
    blackDelete: false, // 블랙리스트 삭제
    comment: false, // 코멘트 설정
    commentDelete: false, // 코멘트 삭제
    kakao: false, // 알림톡 보내기
    excelDownload: false, // 엑셀 다운로드
    couponAndPoint: false, // 쿠폰 및 포인트 설정
    userLog: false, // 유저 로그
    adminLog: false, // 관리자 로그
    sunset: false, // 일몰 시스템 권한
    adminSet: false, // 관리자 권한 설정
    bill: false, // 즉시 결제
    linkidMoney: false, // 링키드 머니 우선 결제
    chat: false, // 채팅 열람
    dash: false, // 대시보드
    uplus: false, // 유플러스
  });

  console.log("❤️ state", authState);

  const { response: authSaveResponse, loading: authSaveLoading } = useApi({
    method: "post",
    url: saveBtnClick ? `auth/${grade?.value}` : undefined,
    data: {
      state:
        (authState?.userInfo ? RoleEnum?.USER_INFO : 0) +
        (authState?.couponAndPoint ? RoleEnum?.COUPON_POINT : 0) +
        (authState?.partyCancel ? RoleEnum?.PARTY_CANCEL : 0) +
        (authState?.partyInfo ? RoleEnum?.PARTY_INFO : 0) +
        (authState?.black ? RoleEnum?.BLACK : 0) +
        (authState?.blackDelete ? RoleEnum?.BLACK_DELETE : 0) +
        (authState?.comment ? RoleEnum?.COMMENT : 0) +
        (authState?.commentDelete ? RoleEnum?.COMMENT_DELETE : 0) +
        (authState?.kakao ? RoleEnum?.KAKAO : 0) +
        (authState?.excelDownload ? RoleEnum?.EXCEL_DOWNLOAD : 0) +
        (authState?.userLog ? RoleEnum?.USERLOG : 0) +
        (authState?.adminLog ? RoleEnum?.ADMIN_LOG : 0) +
        (authState?.sunset ? RoleEnum?.SUNSET : 0) +
        (authState?.adminSet ? RoleEnum?.ADMIN_SET : 0) +
        (authState?.bill ? RoleEnum?.USER_BILL : 0) +
        (authState?.linkidMoney ? RoleEnum?.USER_MONEY : 0) +
        (authState?.chat ? RoleEnum?.CHAT : 0) +
        (authState?.dash ? RoleEnum?.DASH : 0) +
        (authState?.uplus ? RoleEnum?.UPLUS : 0),
    },
  });

  const closeBtnClick = () => {
    if (gradeName !== "") {
      closeEvent();

      toast.success("관리자 등급이 추가 되었습니다.");
    } else {
      closeEvent();
    }
  };

  useEffect(() => {
    if (authListResponse?.status === 200) {
      setAuthState({
        ...authState,
        userInfo: authListResponse?.data[0]?.userInfo,
        partyInfo:
          authListResponse?.status === 200
            ? authListResponse?.data[0]?.partyInfo
            : false, // 파티 정보 열람
        partyCancel:
          authListResponse?.status === 200
            ? authListResponse?.data[0]?.partyCancel
            : false, // 파티 취소
        black:
          authListResponse?.status === 200
            ? authListResponse?.data[0]?.black
            : false, // 블랙리스트 설정
        comment:
          authListResponse?.status === 200
            ? authListResponse?.data[0]?.comment
            : false, // 코멘트 설정
        kakao:
          authListResponse?.status === 200
            ? authListResponse?.data[0]?.kakao
            : false, // 알림톡 보내기
        excelDownload:
          authListResponse?.status === 200
            ? authListResponse?.data[0]?.excelDownload
            : false, // 엑셀 다운로드
        couponAndPoint:
          authListResponse?.status === 200
            ? authListResponse?.data[0]?.couponAndPoint
            : false, // 쿠폰 및 포인트 설정
        userLog:
          authListResponse?.status === 200
            ? authListResponse?.data[0]?.userLog
            : false, // 유저 로그
        adminLog:
          authListResponse?.status === 200
            ? authListResponse?.data[0]?.adminLog
            : false, // 관리자 로그
        sunset:
          authListResponse?.status === 200
            ? authListResponse?.data[0]?.sunset
            : false, // 일몰 시스템 권한
        adminSet:
          authListResponse?.status === 200
            ? authListResponse?.data[0]?.adminSet
            : false, // 관리자 권한 설정
        bill:
          authListResponse?.status === 200
            ? authListResponse?.data[0]?.bill
            : false, // 즉시 결제
        linkidMoney:
          authListResponse?.status === 200
            ? authListResponse?.data[0]?.linkidMoney
            : false, // 링키드 머니 우선 결제
        commentDelete:
          authListResponse?.status === 200
            ? authListResponse?.data[0]?.commentDelete
            : false, // 코멘트 삭제
        chat:
          authListResponse?.status === 200
            ? authListResponse?.data[0]?.chat
            : false, // 채팅 열람
        blackDelete:
          authListResponse?.status === 200
            ? authListResponse?.data[0]?.blackDelete
            : false, // 블랙리스트 삭제
        dash:
          authListResponse?.status === 200
            ? authListResponse?.data[0]?.dash
            : false, // 대시보드
        uplus:
          authListResponse?.status === 200
            ? authListResponse?.data[0]?.uplus
            : false, // 유플러스
      });
    }
  }, [authListResponse]);

  useEffect(() => {
    if (authSaveResponse?.status === 200) {
      closeEvent();

      if (confirmEvent) {
        confirmEvent();
      }

      toast.success("등급 별 권한 설정이 변경되었습니다.");
    }
  }, [authSaveResponse, closeEvent, confirmEvent]);

  useEffect(() => {
    setModalType("input");
  }, []);

  return (
    <DefaultModalLayout
      modalTitle="등급 별 권한 설정"
      closeEvent={() => closeBtnClick()}
      confirmEvent={() => setSaveAlert(true)}
      confirmBtnText="저장"
      confirmDisabled={grade?.value === ""}
      type="input"
    >
      <ModalSection>
        <DeleteModalLabel>관리자 등급 선택</DeleteModalLabel>

        <Flex gapSize={10}>
          <DropDown
            dropdownValue={grade}
            setDropDownValue={setGrade}
            boxWidth={235}
            optionList={gradeOption}
          />

          <ConfirmBtn
            btnText="적용"
            btnColor="mint"
            btnHeight={38}
            isDisabled={grade?.value === ""}
            btnClickEvent={() =>
              setFilter({
                grade: Number(grade?.value),
              })
            }
          />
        </Flex>
      </ModalSection>

      <ModalSection style={{ marginTop: 40 }}>
        <ModalSectionLabel>권한 설정</ModalSectionLabel>

        {filter?.grade === -1 ? (
          <NotSelect>먼저 관리자 등급 선택 후 적용해 주세요.</NotSelect>
        ) : (
          <AuthList>
            {authFuncData
              ?.sort((a, b) => a.state.localeCompare(b.state))
              ?.map((d: IAuthFuncData) => {
                return (
                  <ManagerAuthItem
                    key={d?.id}
                    title={d?.title}
                    desc={d?.desc}
                    check={authState[d?.state as keyof authStateType]}
                    checkEvent={() =>
                      setAuthState({
                        ...authState,
                        [d?.state]: !authState[d?.state as keyof authStateType],
                      })
                    }
                  />
                );
              })}
          </AuthList>
        )}
      </ModalSection>

      <>
        {saveAlert && (
          <AlertModal
            title={`등급 별 권한 설정이 변경됩니다. 
      계속 하시겠습니까?
      `}
            btnColor="mint"
            confirmText="계속"
            cancelEvent={() => setSaveAlert(false)}
            confirmEvent={() => setSaveBtnClick(true)}
          />
        )}

        {(authSaveLoading || authLoading) && <Loader />}
      </>
    </DefaultModalLayout>
  );
}

const ModalSection = styled.section`
  width: 100%;
`;

const ModalSectionLabel = styled.div`
  font-size: 15px;
  font-weight: 700;
  line-height: 22.5px;
  text-align: left;
  color: ${({ theme }) => theme.color.gray700};
`;

const AuthList = styled.ul`
  width: 100%;
  margin-top: 40px;
`;

const NotSelect = styled.p`
  margin-top: 40px;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: left;
  color: #aaaaaa;
`;
